import React, { useRef } from "react"
import { Button, Grid } from "@mui/material"
import Map, { Source, Layer } from "react-map-gl"
import { initialViewState, MAPBOX_TOKEN, MAP_STYLE } from "../../constants"
import mapboxgl from "mapbox-gl" // This is a dependency of react-map-gl even if you didn't explicitly install it

mapboxgl.workerClass =
  // eslint-disable-next-line import/no-webpack-loader-syntax
  require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default

const layerStyle = {
  id: "farmlayer",
  type: "circle",
  source: "farmSource",
  paint: {
    "circle-radius": 20,
    "circle-color": "#223b53",
    "circle-stroke-color": "white",
    "circle-stroke-width": 2,
    "circle-opacity": 0.6,
  },
}

export default function FarmsMap({ farmsGeoJson, setActiveFarm }) {
  const mapRef = useRef()

  const handleMapClick = (e) => {
    const bbox = [
      [e.point.x - 5, e.point.y - 5],
      [e.point.x + 5, e.point.y + 5],
    ]
    // Find features intersecting the bounding box.
    const selectedFeatures = mapRef.current.queryRenderedFeatures(bbox)
    const circles = selectedFeatures.filter((f) => f.layer.id === "farmlayer")
    if (circles.length > 0) {
      setActiveFarm(circles[0].properties.id)
    }
  }

  return (
    <>
      <Grid container>
        <Grid item xs={12} style={{ zIndex: 10 }}>
          <Button variant="outlined" href="/add-farm">
            Manage Farms
          </Button>
        </Grid>
      </Grid>
      <Map
        initialViewState={initialViewState}
        mapStyle={MAP_STYLE}
        mapboxAccessToken={MAPBOX_TOKEN}
        style={{ width: "100%", height: "calc(100vh - 200px)" }}
        interactiveLayerIds={["farmlayer"]}
        onClick={handleMapClick}
        ref={mapRef}
      >
        <Source id="farms" type="geojson" data={farmsGeoJson}>
          <Layer {...layerStyle} />
        </Source>
      </Map>
      ;
    </>
  )
}
